// src/components/about/ValuesSection.js
import React from 'react';

// 1. Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// 2. Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import 'swiper/css/scrollbar'; // Optionnel pour une barre de défilement
// import 'swiper/css/effect-fade'; // Optionnel pour d'autres effets

// 3. Import Swiper modules
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';

import './ValuesSection.css';

// Données pour les valeurs (inchangées)
const valuesData = [
  {
    id: 'collaboration',
    icon: '🤝',
    title: 'Collaboration',
    description: 'Nous travaillons main dans la main avec nos clients, considérant chaque projet comme un partenariat.'
  },
  {
    id: 'innovation',
    icon: '💡',
    title: 'Innovation',
    description: 'Nous sommes constamment à l\'affût des nouvelles technologies et approches pour offrir des solutions avant-gardistes.'
  },
  {
    id: 'qualite',
    icon: '⭐',
    title: 'Qualité',
    description: 'L\'excellence est au cœur de tout ce que nous faisons, du design au code, en passant par le support.'
  },
  {
    id: 'transparence',
    icon: '🔍',
    title: 'Transparence',
    description: 'Nous communiquons ouvertement et honnêtement à chaque étape du projet.'
  },
  {
    id: 'engagement',
    icon: '🚀',
    title: 'Engagement',
    description: 'Nous sommes dévoués au succès de nos clients et mettons tout en œuvre pour dépasser leurs attentes.'
  }
];

function ValuesSection() {
  return (
    <section className="about-section values-section-container">
      <h2>Nos Valeurs Fondamentales</h2> {/* Titre de la section, stylé par CSS */}

      <Swiper
        // 4. Installer les modules
        modules={[Navigation, Pagination, A11y, Autoplay]}
        spaceBetween={30} // Espace entre les slides
        slidesPerView={1} // Par défaut 1 slide visible
        loop={true} // Boucle infinie
        centeredSlides={true}
        autoplay={{
          delay: 4000, // Délai entre les transitions
          disableOnInteraction: false, // L'autoplay ne s'arrête pas après interaction utilisateur
        }}
        pagination={{ clickable: true }} // Permet de cliquer sur les points de pagination
        navigation // Active les flèches de navigation
        grabCursor={true}
        // Responsive breakpoints
        breakpoints={{
          // quand la largeur de la fenêtre est >= 640px
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          // quand la largeur de la fenêtre est >= 1024px
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
        className="values-swiper-container" // Classe pour styler le conteneur Swiper si besoin
      >
        {valuesData.map(value => (
          // Chaque élément de valuesData devient un SwiperSlide
          <SwiperSlide key={value.id} className="value-slide">
            {/* Le contenu de la carte est ici, réutilisant la structure et les classes de value-card */}
            <div className="value-card"> {/* Appliquer la classe value-card ici */}
              <div className="value-icon-wrapper">
                <span className="value-icon" role="img" aria-hidden="true">{value.icon}</span>
              </div>
              <h3 className="value-title">{value.title}</h3>
              <p className="value-description">{value.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default ValuesSection;